import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=74364c00&"
import script from "./Breadcrumb.ts?vue&type=script&lang=js&"
export * from "./Breadcrumb.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports